import { axiosInstance } from './rest';

export function createZendeskTicket(ticketDTO) {
  return axiosInstance.post('/api/v2/companies/supportTickets', ticketDTO);
}